import React from 'react';

// Tipos de marcação do calendário do período avaliativo.
// "letivo" fica em schoolDays (como sempre); os outros ficam em nonSchoolDays: [{ date, type, description }].
export const TIPOS_DIA = {
    letivo: { label: 'Dia letivo', plural: 'Dias letivos', cor: '#12b981', borda: '#0d9f6e', icone: '📘' },
    feriado: { label: 'Feriado', plural: 'Feriados', cor: '#ef4444', borda: '#dc2626', icone: '🎉' },
    recesso: { label: 'Recesso', plural: 'Recessos', cor: '#f59e0b', borda: '#d97706', icone: '🏖️' },
    outro: { label: 'Outro', plural: 'Outros', cor: '#8b5cf6', borda: '#7c3aed', icone: '📌' },
};
export const TIPOS_NAO_LETIVOS = ['feriado', 'recesso', 'outro'];

// Chave YYYY-MM-DD lida em UTC (datas salvas são meia-noite UTC)
export const chaveUTC = (value) => {
    const dt = new Date(value);
    if (isNaN(dt.getTime())) return null;
    return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
};

// Mapa chave -> { type, description }
export const mapaNaoLetivos = (lista = []) => {
    const m = new Map();
    (lista || []).forEach((d) => {
        const k = chaveUTC(d.date);
        if (k && TIPOS_NAO_LETIVOS.includes(d.type)) m.set(k, { type: d.type, description: d.description || '' });
    });
    return m;
};

// { feriado: n, recesso: n, outro: n }
export const contarNaoLetivos = (lista = []) => {
    const c = { feriado: 0, recesso: 0, outro: 0 };
    (lista || []).forEach((d) => { if (c[d.type] !== undefined) c[d.type] += 1; });
    return c;
};

// Estilo inline de uma célula marcada como feriado/recesso/outro
export const estiloMarcacao = (type) => {
    const t = TIPOS_DIA[type];
    if (!t) return undefined;
    return { background: t.cor, borderColor: t.borda, color: '#fff', fontWeight: 700, opacity: 1, cursor: 'pointer' };
};

export const tituloDoDia = (key, mark) => {
    const data = key.split('-').reverse().join('/');
    if (!mark) return data;
    const t = TIPOS_DIA[mark.type];
    return `${data} — ${t?.label || ''}${mark.description ? `: ${mark.description}` : ''}`;
};

/** Seletor "Marcar como": Dia letivo | Feriado | Recesso | Outro (+ descrição opcional). */
export function SeletorMarcacao({ modo, setModo, descricao, setDescricao }) {
    return (
        <div style={{ margin: '4px 0 12px' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-muted, #5b6b72)', marginBottom: 6 }}>
                Ao tocar num dia, marcar como:
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {Object.entries(TIPOS_DIA).map(([id, t]) => {
                    const ativo = modo === id;
                    return (
                        <button
                            key={id}
                            type="button"
                            onClick={() => setModo(id)}
                            aria-pressed={ativo}
                            style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '8px 14px', borderRadius: 999, cursor: 'pointer',
                                fontSize: 13, fontWeight: 700,
                                border: `2px solid ${t.cor}`,
                                background: ativo ? t.cor : 'transparent',
                                color: ativo ? '#fff' : t.borda,
                            }}
                        >
                            <span aria-hidden>{t.icone}</span> {t.label}
                        </button>
                    );
                })}
            </div>
            {modo !== 'letivo' && (
                <input
                    type="text"
                    value={descricao}
                    maxLength={80}
                    onChange={(e) => setDescricao(e.target.value)}
                    placeholder={
                        modo === 'feriado' ? 'Nome do feriado (opcional) — ex.: Tiradentes'
                            : modo === 'recesso' ? 'Descrição (opcional) — ex.: Recesso escolar de julho'
                                : 'Descrição (opcional) — ex.: Conselho de classe'
                    }
                    style={{
                        marginTop: 8, width: '100%', boxSizing: 'border-box',
                        padding: '9px 12px', borderRadius: 8,
                        border: '1px solid var(--line, #e1e7f0)',
                        background: 'var(--surface, #fff)', color: 'var(--text, #16323b)', fontSize: 14,
                    }}
                />
            )}
            <div style={{ fontSize: 12, color: 'var(--text-muted, #5b6b72)', marginTop: 6 }}>
                Toque de novo no mesmo dia para desmarcar.
            </div>
        </div>
    );
}

/** Itens extras da legenda (feriado, recesso, outro). */
export function LegendaNaoLetivos({ Item, Swatch }) {
    return TIPOS_NAO_LETIVOS.map((id) => (
        <Item key={id}>
            <Swatch style={{ background: TIPOS_DIA[id].cor, borderColor: TIPOS_DIA[id].borda }} /> {TIPOS_DIA[id].label}
        </Item>
    ));
}
